/*
    https://eweb8.vfd2-testnet.de/api/appointmentman/v1/calendar/freeslots/200531314?startdate=05.12.2017&enddate=06.12.2017
*/

export default <any>{
    appointman: {
        sandbox: false,
        api: {
            BASE_URI: 'https://eweb8.vfd2-testnet.de/api/appointmentman/v1',
            SHOPFINDER_URI: '/filialsuche.html'
        },
        apmTypeMapping: {
            'Service': 'SVC',
            'Beratung': 'BER',
            'Geschäftlich': 'BUS',
            'Reparatur-Service': 'REP',
            'TV-Grundversorgung': 'TVG'
        },
        selectors: {
            appContainer: '.app-appointman',
            roamingStepper: '.custom-roaming-stepper'
        },
        flow: {
            SELECT_SHOP: 0x00,
            CHOOSE_TYPE: 0x01,
            CHOOSE_DATE: 0x02,
            CONTACT_DETAILS: 0x03,
            SUMMARY: 0x04
        },
        msg: {
            SELECT_SHOP_PREVIEW: '<strong>Dein Shop:</strong> Vodafone Shop / %s',
            CHOOSE_DATE_PREVIEW: '<strong>Dein Termin:</strong> %s',
            CHOOSE_DATE_ACTIVE: 'Wähle einen Termin aus',
            CHOOSE_TYPE_PREVIEW: '<strong>Deine Terminart:</strong> %s',
            CHOOSE_TYPE_ACTIVE: 'Wähle deine Terminart',
            CHOOSE_TYPE_API: {
                'BER_LABEL': 'Beratung',
                'BER_DESCRIPTION': 'Du interessierst Dich für unser Produkt-Portfolio?',
                'BUS_LABEL': 'Geschäftlich',
                'BUS_DESCRIPTION': 'Sie besitzen einen Gewerbeschein, sind selbständig oder haben bereits einen Business-Rahmenvertrag mit einem Geschäftskundentarif?',
                'SVC_LABEL': 'Service',
                'SVC_DESCRIPTION': 'Du hast Fragen zu Deiner Rechnung, zur Hardware oder möchtest Deine Vertrags- und Stammdaten ändern?',
                'REP_LABEL': 'Reparatur-Service',
                'REP_DESCRIPTION': 'Dir ist Dein Smartphone oder Mac kaputtgegangen? Wir kümmern uns in kürzester Zeit um die Reparatur.',
                'TVG_LABEL': 'TV-Grundversorgung',
                'TVG_DESCRIPTION': 'Unsere Expert:innen vor Ort sorgen dafür, dass Du auch in Zukunft nicht schwarz siehst. Von der TV-Grundversorgung (Kabel-TV) bis hin zu Premium-TV inklusive Streaming: bei uns erhältst Du alles aus einer Hand.'
            },
            CONTACT_DETAILS_PREVIEW: '<strong>Deine Kontaktdaten:</strong> %s',
            CONTACT_DETAILS_ACTIVE: 'Deine Kontaktdaten',
            CONTACT_DETAILS_VALIDATION: {
                'FIRSTNAME_MISSING': 'Bitte Vornamen eingeben',
                'FIRSTNAME_INVALID': 'Vorname ungültig',
                'FIRSTNAME_TOOLONG': 'Der Wert darf nicht mehr als 400 Zeichen überschreiten.',
                'LASTNAME_MISSING': 'Bitte Nachnamen eingeben',
                'LASTNAME_INVALID': 'Nachname ungültig',
                'LASTNAME_TOOLONG': 'Der Wert darf nicht mehr als 400 Zeichen überschreiten.',
                'EMAIL_MISSING': 'Bitte E-Mail-Adresse eingeben',
                'EMAIL_INVALID': 'E-Mail Adresse ist ungültig',
                'EMAIL_TOOLONG': 'E-Mail Adresse darf nicht mehr als 400 Zeichen überschreiten.',
                'PHONE_MISSING': 'Bitte Handy-Nummer angeben',
                'PHONE_INVALID': 'Handy-Nummer ist ungültig',
                'PHONE_TOOLONG': 'Handy-Nummer dart nicht mehr als 400 Zeichen überschreiten.',
                'TOPIC_MISSING': 'Bitte Thema auswählen',
                'TEXT_TOOLONG': 'Die Nachricht darf nicht mehr als 6000 Zeichen überschreiten.'
            },
            CONTACT_DETAILS_SELECT_LABEL: 'Bitte wähle ein Thema aus',
            SUMMARY_LOADING_LABEL: 'Bitte warten...',
            SUMMARY_ACTIVE_LABEL: 'Terminvereinbarung absenden',
            SUMMARY_UPDATE_LABEL: 'Terminvereinbarung aktualisieren',
            ARCHIVE_LOADING_LABEL: 'Bitte warten...',
            ARCHIVE_ACTIVE_LABEL: 'Termin stornieren',
            SUCCESS_TITLE_CREATED: 'Vielen Dank für Deine Terminbuchung',
            SUCCESS_TITLE_UPDATED: 'Vielen Dank für Deine Terminänderung',
            SUCCESS_TITLE_ARCHIVED: 'Vielen Dank für Deine Terminstornierung'
        }
    }
};



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/config.ts